import React, { useState, useEffect } from 'react';
import { fileActions } from '../../store/actions';
import { useDispatch, useSelector } from 'react-redux'
import { Typography } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'

import { GenericButtonList, GenericStatusElement, CustomLoadingOverlay, GenericContainer, Buttons, GenericContainerCenter } from '../../components'
import { coreFunctions } from '../../utils'
import { useTranslation } from 'react-i18next';

export default function CreditSelectionComponent(props) {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [loadView, setLoadView] = useState(false)
  const [title, setTitle] = useState('')
  const [subtitle, setSubtitle] = useState('')
  const [fileId, setFileId] = useState(0)
  const [activeInitial, setActiveInitial] = useState(false)
  const [listCreditOptions, setListCreditOptions] = useState([])

  const [stageProps, setStageProps] = useState(0)

  //Redux hooks
  const file = useSelector(state => state.FileInfo)
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(fileActions.GetFileInfo(location.state.folioId));
    setLoadView(true)
    if (!activeInitial) {
      setFileId(location.state.folioId)
      setActiveInitial(true)
    }
  }, [])

  useEffect(() => {
    if (file.items != undefined && loadView) {
      setStageProps(file.items?.Stage)
    }
  }, [file])

  useEffect(() => {
    if (stageProps != 0 && loadView) {
      console.log('stage', stageProps)
      setTitle(stageProps.Description)
      setSubtitle('Selecciona la opción de crédito que más te interese o personaliza tu crédito.')
      getCreditOptions()
      setLoadView(false)
    }
  }, [stageProps])

  let getCreditOptions = () => {
    let itemsToList = []
    let optionsValues = stageProps.Properties.find(item => item.Name == "Options")
    let optionsArray = JSON.parse(optionsValues.Value);

    if (optionsArray.length <= 0) {
      let folioId = fileId
      let nextComponent = "CalculatorComponent"
      coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId } })
    } else {
      let arrayNew = optionsArray.map((item, index) => {
        return {
          ...item,
          index: index,
          IsCalculator: "false"
        }
      });
      setListCreditOptions(arrayNew)
    }
  }

  let handleCalculator = (e) => {
    let nextStage = stageProps
    if (nextStage != null && nextStage != undefined) {
      let stageName = nextStage.Name
      let stageId = nextStage.Id
      let folioId = fileId
      let stage = location.state.stage

      let nextComponent = "CalculatorComponent"
      coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
    }
  }

  return (
    <GenericContainer>
      <GenericContainerCenter dynamicSize={200} >
        <Typography variant="h6" gutterBottom >
          {title}
        </Typography>
        <Typography variant="subtitle1" gutterBottom >
          {subtitle}
        </Typography>

        {listCreditOptions.map((itemData, index) => {
          console.log(itemData)
          return <GenericButtonList
            key={`${index}`}
            onClick={() => {
              let nextStage = file.items?.Stage
              let stageName = nextStage.Name
              let stageId = nextStage.Id
              let folioId = fileId
              let stage = file.items
              let items = itemData
              let nameReturn = "CreditSelectionComponent"

              let nextComponent = "CreditOfferComponent"
              coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId, items, nameReturn } })
            }}
          >
            <GenericStatusElement
              id={`list_element_key_${itemData.index}`}
              text={itemData.Monto}
              description={itemData.Plazo}
              descuento={itemData.descuento}
              statusColor={itemData.Status}
            />
          </GenericButtonList>
        })}
      </GenericContainerCenter>
      <Buttons ConfirmButtonText='Personalizar crédito'
        onClickConfirm={handleCalculator} />

      {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
    </GenericContainer>)
}